import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../api";
import { toast } from "react-toastify";
import {
  // FaFlask,
  FaSearch,
  FaTools,
  FaFilter,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useData } from "../../context/DataContext";
import AddInvLab from "../../components/invlab/AddInvLab";
import Edit from "../../components/action/Edit";
import Hapus from "../../components/action/Hapus";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FaFlask, FaBuilding } from 'react-icons/fa';
import dayjs from 'dayjs';
import { SipDropdown, SipSearch } from "../../components/form/SipControls";
// Import PrimeReact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const InventarisLab = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const { lab, getLabs } = useData();

  // ==================== STATE MANAGEMENT ====================
  // State untuk pencarian dan filter
  const [searchTerm, setSearchTerm] = useState("");
  const [kondisiFilter, setKondisiFilter] = useState("");
  const [labFilter, setLabFilter] = useState("");
  const [loading, setLoading] = useState(false);



  // State untuk data
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);

  // State untuk modal dan form
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({
    id: "",
    lab_id: "",
    inventaris_id: "",
    kondisi: "",
    ket: "",
    desc: "",
    merk: "",
  });

  const resetData = () => {
    setForm({
      id: "",
      lab_id: "",
      inventaris_id: "",
      kondisi: "",
      ket: "",
      desc: "",
      merk: "",
    });
  };

  const openModal = (item = null) => {
    if (item) {
      setForm(item);
      setIsEditing(true);
    } else {
      resetData();
      setIsEditing(false);
    }
    setIsModalOpen(true);
  };

  // ==================== API FUNCTIONS ====================
  const getInvLab = async () => {
    try {
      setLoading(true);
      // Membangun query parameters
      const params = new URLSearchParams();
      const queryString = params.toString();
      const url = `/mon/inv-lab${queryString ? `?${queryString}` : ""}`;

      const res = await Api.get(url);
      setRows(res.data.data || []);
      setError(null);
    } catch (error) {
      console.error("Error fetching inventaris data:", error);
      setError("Gagal mengambil data inventaris. Silakan coba lagi.");
      toast.error("Gagal mengambil data inventaris. Silakan coba lagi.");
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menambah/update inventaris lab
  const postInvLab = async () => {
    try {
      setLoading(true);

      // Validasi form
      if (!form.lab_id || !form.inventaris_id || !form.kondisi) {
        toast.error("Mohon lengkapi semua field yang wajib diisi");
        return false;
      }
      await Api.post("/mon/inv-lab", form);
      toast.success("Data inventaris berhasil disimpan!");
      await getInvLab();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error posting inventaris data:", error);

      let errorMessage = "Gagal menyimpan data inventaris. ";
      if (error.response) {
        errorMessage += `Server error: ${error.response.status} - ${
          error.response.data?.message || "Unknown error"
        }`;
      } else if (error.request) {
        errorMessage +=
          "Tidak dapat terhubung ke server. Periksa koneksi internet Anda.";
      } else {
        errorMessage +=
          error.message || "Terjadi kesalahan yang tidak diketahui.";
      }

      toast.error(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menghapus inventaris lab
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await Api.delete(`/mon/inv-lab/${id}`);
      toast.success("Data inventaris berhasil dihapus!");
      getInvLab()
    } catch (error) {
      console.error("Error deleting inventaris data:", error);
      toast.error("Gagal menghapus data inventaris. Silakan coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit=async(id)=>{
    try {
      const res=await Api.get(`/mon/inv-lab/${id}`)
      setForm({
        id:res.data.data.id,
        lab_id:res.data.data.lab_id || "",
        inventaris_id:res.data.data.inventaris_id || "",
        kondisi:res.data.data.kondisi || "",
        ket:res.data.data.ket || "",
        desc:res.data.data.desc || "",
        merk:res.data.data.merk || ""
      })
       setIsEditing(true);
       setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching data for edit:", error);
      toast.error("Gagal mengambil data untuk edit!");
    }
  }

  // ==================== USEEFFECT ====================
  useEffect(() => {
    getInvLab();
    getLabs();
  }, []);

  // Filter data berdasarkan pencarian dan filter
  const filteredData = rows.filter((item) => {
    const matchesSearch =
      item.inventaris_desc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.kode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.nama_lab?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesKondisi =
      kondisiFilter === "" ||
      kondisiFilter === "all" ||
      item.kondisi?.toLowerCase() === kondisiFilter.toLowerCase();

    const matchesLab =
      labFilter === "" ||
      (item.lab_id &&
        typeof item.lab_id === "string" &&
        item.lab_id.toLowerCase() === labFilter.toLowerCase()) ||
      (item.nama_lab &&
        typeof item.nama_lab === "string" &&
        item.nama_lab.toLowerCase() === labFilter.toLowerCase());

    return matchesSearch && matchesKondisi && matchesLab;
  });



  // Status badge function
  const getStatusBadge = (kondisi) => {
    if (!kondisi) {
      return "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800";
    }

    switch (kondisi.toLowerCase()) {
      case "baik":
        return "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800";
      case "rusak":
        return "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800";
      default:
        return "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800";
    }
  };

  // Reset filters
  const resetFilters = () => {
    setSearchTerm("");
    setKondisiFilter("");
    setLabFilter("");
  };

  return (
    <div className="space-y-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* ==================== HEADER SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-primary px-6 py-8 md:px-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Judul Halaman */}
              <div className="text-white">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-white/20 rounded-lg">
                    <FaFlask className="text-xl" />
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    Inventaris Laboratorium
                  </h1>
                </div>
                <p className="text-white/80 text-sm md:text-base">
                  Pantau dan kelola inventaris laboratorium
                </p>
              </div>

              {/* Tombol Kembali */}
              <motion.button
                onClick={handleBack}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300 shadow-lg"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span className="font-medium">Kembali</span>
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* ==================== SEARCH AND FILTER SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {/* Tombol Tambah Inventaris */}
          <div className="flex justify-end">
            <div className="mb-6">
              <AddInvLab
                openModal={openModal}
                isModalOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                form={form}
                setForm={setForm}
                postInvLab={postInvLab}
                isEditing={isEditing}
                resetData={resetData}
              />
            </div>
          </div>

          {/* Search Bar dan Filter dalam satu baris */}
          <div className="grid grid-cols-1 xl:grid-cols-4 gap-4 mb-6">
            {/* Search Bar */}
            <div className="lg:col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaSearch className="inline mr-2" />
                Pencarian
              </label>
              <SipSearch
                placeholder="Cari inventaris..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Kondisi Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaFilter className="inline mr-2" />
                Kondisi
              </label>
              <SipDropdown
                value={kondisiFilter}
                onChange={(e) => setKondisiFilter(e.target.value)}
                placeholder="Semua Kondisi"
                options={[
                  { label: "Semua Kondisi", value: "" },
                  { label: "Baik", value: "baik" },
                  { label: "Rusak", value: "rusak" },
                ]}
              />
            </div>

            {/* Lab Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <FaTools className="inline mr-2" />
                Nama Lab
              </label>
              <SipDropdown
                value={labFilter}
                onChange={(e) => setLabFilter(e.target.value)}
                placeholder="Semua Lab"
                options={[
                  { label: "Semua Lab", value: "" },
                  ...(lab || []).map((labItem) => ({
                    label: `${labItem.id}-${labItem.nama_lab}`,
                    value: labItem.nama_lab,
                  })),
                ]}
              />
            </div>

            {/* Reset Filters */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                &nbsp;
              </label>
              <button
                onClick={resetFilters}
                className="w-full px-4 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all duration-300"
              >
                Reset Filter
              </button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-gray-200">
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">
                {filteredData.length}
              </div>
              <div className="text-sm text-gray-500">Total Inventaris</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">
                {
                  filteredData.filter(
                    (item) => item.kondisi?.toLowerCase() === "baik"
                  ).length
                }
              </div>
              <div className="text-sm text-gray-500">Kondisi Baik</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-red-600">
                {
                  filteredData.filter(
                    (item) => item.kondisi?.toLowerCase() === "rusak"
                  ).length
                }
              </div>
              <div className="text-sm text-gray-500">Kondisi Rusak</div>
            </div>
          </div>
        </motion.div>

        {/* ==================== TABLE SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {/* PrimeReact DataTable */}
          <div className="p-6">
            <DataTable
              value={filteredData}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
              emptyMessage="Tidak ada data inventaris lab yang tersedia"
              loading={loading}
              stripedRows
              showGridlines
              responsiveLayout="scroll"
              className="p-datatable-sm"
            >
              {/* Template untuk kode */}
              <Column 
                field="kode" 
                header="Kode" 
                style={{ minWidth: '120px' }}
                sortable
              />

              {/* Template untuk nama inventaris */}
              <Column 
                field="inventaris_desc" 
                header="Nama Inventaris" 
                body={(rowData) => (
                  <div>
                    <div className="text-sm font-medium text-gray-900">
                      {rowData.inventaris_desc}
                    </div>
                    <div className="text-sm text-gray-500">
                      {rowData.merk}
                    </div>
                  </div>
                )}
                style={{ minWidth: '250px' }}
                sortable
              />

              {/* Template untuk lab */}
              <Column 
                field="nama_lab" 
                header="Lab" 
                body={(rowData) => (
                  <div className="flex items-center gap-2">
                    <FaBuilding className="text-gray-400 text-sm" />
                    <span className="text-sm text-gray-900">{rowData.nama_lab}</span>
                  </div>
                )}
                style={{ minWidth: '150px' }}
                sortable
              />

              {/* Template untuk kondisi */}
              <Column 
                field="kondisi" 
                header="Kondisi" 
                body={(rowData) => (
                  <span className={getStatusBadge(rowData.kondisi)}>
                    {rowData.kondisi}
                  </span>
                )}
                style={{ minWidth: '120px' }}
                sortable
              />

              {/* Template untuk tahun */}
              <Column 
                field="tgl" 
                header="Tahun" 
                body={(rowData) => (
                  <span className="text-sm text-gray-900">
                    {dayjs(rowData.tgl).format("YYYY")}
                  </span>
                )}
                style={{ minWidth: '100px' }}
                sortable
              />

              {/* Template untuk aksi */}
              <Column 
                field="id" 
                header="Aksi" 
                body={(rowData) => (
                  <div className="flex items-center gap-2">
                    <Edit id={rowData.id} handleEdit={handleEdit} />
                    <Hapus id={rowData.id} handleDelete={handleDelete} />
                  </div>
                )}
                style={{ minWidth: '100px', textAlign: 'center' }}
                sortable={false}
              />
            </DataTable>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default InventarisLab;
